import React, {Component} from 'react'
import * as config from '../Configuration/Config.js'
import * as pbi from 'powerbi-client';
import UserProfile from '../Configuration/UserProfile.js'

class ResourcesExample extends Component {
    componentDidMount() {
        var rid = "";
        var gid = "";

        var p = new UserProfile()
        const uid = p.UserId();
        if (uid === "3068d73b-2646-43d2-8670-36c70b830fc7") {
            rid = "46f1b213-1443-4927-9858-0ae0cabb6e6c ";
            gid = "1c3185b6-be40-490d-938f-f2cba4af9265";
        } else if (uid === "88103bfc-75b2-429b-b31b-8944314fa0e5") {
            rid = "a3e07bfd-281d-4f57-83d4-a23c0d039a1c ";
            gid = "daf0efe7-aca9-43c6-b725-0f2bba02480a";
        } else if (uid === "6608c3ec-84df-4fbb-a2e9-273c6b37fada") {
            rid = "3ea2dad5-103e-4b68-bcff-a483d85b2812 ";
            gid = "008e0b77-4f03-4c86-8ae3-2d79c7485639";
        } else if (uid === "9f789e0e-d9fb-40cf-bf57-e677b7551b10") {
            rid = "ed6f2ba1-1537-4912-9001-c916dc6f8fcc";
            gid = "b43204cd-e534-4360-b9f0-acdf1efc4b18";            
        } else {
            return;
        }
        
        const uri = config.getUriPath('visualizations/embedToken?id=' + rid + '&group_id=' + gid)
        fetch(uri, {
            method: 'get',
            headers: config.ApiHeaders()
           }).then(function(response) {
            if (response.status >= 400) {
              throw new Error("Bad response from server");
            }

            if (response.status >= 204) {
                return null;
            }

            return response.json();
          })
          .then(function(data) {
            if (data == null) {
                return;
            }

            const embedUrl = "https://app.powerbi.com/reportEmbed?reportId=" + rid + "&groupId=" + gid;

            var pbiconfig = {
                type: 'report',
                tokenType: 1,
                accessToken: data.token,
                embedUrl: embedUrl,
                id: rid,
                permissions: 7,
                settings: {
                  filterPaneEnabled: true,
                  navContentPaneEnabled: true
                  }
                };

                let powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory);
                var reportContainer = document.getElementById('rptContainer');
                
               powerbi.embed(reportContainer, pbiconfig);    
          });
    }

    render() {
        return <div>
                    {/* <div className="resourceTop">
                            <h4>Data Inventory</h4>
                            <br />
                            The data inventory is a compilation of information on data tables, table joins, fields and definitions found in the Acumen dataset.  
                            This is to ensure proper clarity and understanding of fields and measures for all users of the Acumen reports. Report pages include:
                            <br />
                            <ul>
                                <li>Summary Info - Overview of dataset with number of tables, records and database name</li>
                                <li>Tables & Columns - Dictionary of all fields and tables available to report users</li>
                                <li>Relationships - Visual and table representation of joins within Acumen dataset</li>
                                <li>Measures - All measures (created Power BI calculations) within Acumen, includes full DAX definition</li>
                            </ul>
                    </div> */}
                    <div className="center-div">
                        <div className="resourceReport" id="rptContainer">&nbsp;</div>
                    </div>
                </div>
    }
}

export default ResourcesExample


// WEBPACK FOOTER //
// ./src/Components/Resources/ResourcesExample.js